import SubHeader from "components/SubHeader";
import SubHeaderTitle from "components/SubHeader/SubHeaderTitle";
import ActionsBar from "components/SubHeader/ActionsBar";
import { useTranslation } from "react-i18next";
import { format } from "date-fns-jalali";
import { LiveIndicator } from "./LiveIndicator";

type TProps = {
  title: string;
  lastUpdated?: Date;
  /** Last fetch attempt (success or failure) — the countdown reference. */
  lastAttempt?: Date;
  /** Poll interval of the page, so the countdown matches its own schedule. */
  refreshIntervalMs?: number;
  isLoading?: boolean;
  /** A background poll is in flight — shown without hiding the data. */
  isRefetching?: boolean;
  onRefresh: () => void;
};

/** Common sub header for report pages: title, last update time, refresh. */
export function ReportSubHeader({
  title,
  lastUpdated,
  lastAttempt,
  refreshIntervalMs,
  isLoading,
  isRefetching,
  onRefresh,
}: TProps) {
  const { t } = useTranslation();
  return (
    <SubHeader>
      <SubHeaderTitle>{title}</SubHeaderTitle>
      <div className="flex items-center gap-3">
        {!!refreshIntervalMs && (
          <LiveIndicator
            lastUpdated={lastUpdated}
            lastAttempt={lastAttempt}
            refreshIntervalMs={refreshIntervalMs}
            isRefetching={isRefetching}
          />
        )}
        {lastUpdated && (
          <span className="text-tiny text-gray-90 whitespace-nowrap">
            {`${t("lastUpdate")}: ${format(lastUpdated, "HH:mm:ss")}`}
          </span>
        )}
        <ActionsBar
          requestTime={0}
          showRequestTime={false}
          actionButtons={[
            {
              iconName: "MdRefresh",
              buttonTooltip: t("refresh"),
              action: onRefresh,
              // Spins for background polls too, so an automatic refresh is
              // visible and not just a number resetting to the top.
              showLoading: isLoading || isRefetching,
              id: "report_refresh",
            },
          ]}
        />
      </div>
    </SubHeader>
  );
}

export default ReportSubHeader;
